import type { BasketOrderItem } from "../../hooks";
import { H5 } from "@sellar-io/components";
import {
  CaseSizeRuleCreateRequestType,
  SupplierGetResponseType,
} from "@sellar-io/api-v2/types";
import { Fragment } from "react";
import { OrderDiscountSummaryItem } from "./OrderDiscountSummaryItem";
import { getItemTypeTitle } from "./lib/getItemTypeTitle";

type SortedDiscounts = {
  type: string;
  discounts: SupplierGetResponseType["CustomerZones"][number]["PriceTier"]["PriceTierDiscounts"];
}[];

type PriceTierDiscountsType =
  SupplierGetResponseType["CustomerZones"][number]["PriceTier"]["PriceTierDiscounts"];

const sortDiscounts = (discounts: PriceTierDiscountsType | undefined) => {
  if (!discounts) return;
  const sortedItems: SortedDiscounts = [];

  discounts.forEach((item) => {
    const itemTypeTitle = getItemTypeTitle(item);
    const existingObject = sortedItems.find(
      (obj) => obj.type === itemTypeTitle,
    );

    if (existingObject) {
      existingObject.discounts.push(item);
    } else {
      sortedItems.push({
        type: itemTypeTitle,
        discounts: [item],
      });
    }
  });

  return sortedItems;
};

export function OrderDiscountSummary({
  discounts,
  currency,
  hideInfo,
  caseSizeRuleList,
  orderItems,
  activeDiscountIds,
}: {
  discounts?: PriceTierDiscountsType;
  currency?: string;
  hideInfo?: boolean;
  caseSizeRuleList: CaseSizeRuleCreateRequestType[];
  orderItems?: BasketOrderItem[];
  activeDiscountIds?: number[];
}) {
  const sortedDiscounts = sortDiscounts(discounts);

  return (
    <div>
      {sortedDiscounts?.map((sortedDiscount, i) => (
        <Fragment key={i}>
          <H5 className={"mt-1 mb-0.5"}>{sortedDiscount.type.toUpperCase()}</H5>
          {sortedDiscount.discounts
            .sort((a, b) => byQuantity(a.quantity, b.quantity))
            .map((discount) => (
              <OrderDiscountSummaryItem
                key={discount.id}
                discount={discount}
                currency={currency}
                caseSizeRuleList={caseSizeRuleList}
                orderItems={orderItems}
                activeDiscountIds={activeDiscountIds}
              />
            ))}
        </Fragment>
      ))}
      {!hideInfo && <>(Discounts automatically calculated in basket)</>}
    </div>
  );
}

const byQuantity = (a: number, b: number) => {
  return a - b;
};
